'use strict';

/* eslint new-cap: 0 */
/* eslint no-cond-assign: 0 */
var gSTB = top.gSTB,
    stbStorage = top.stbStorage,
    gettext = require('mag-gettext').gettext,
    imageDate = '',
    activeBank = gSTB.GetDeviceActiveBank(),
    model = gSTB.GetDeviceModelExt ? gSTB.GetDeviceModelExt() : gSTB.GetDeviceModel(),
    realActiveBank, deviceInfo;

if ( realActiveBank = stbStorage.getItem('nandEmergencyLoadingLogs') ) {
    activeBank = (JSON.parse(realActiveBank) || '').bootmedia + ' (' + gettext('emergency mode') + ')';
}

if ( model === 'emulator_stb' || model === 'emulator' || model === 'AndroidSTB' || model === 'AndroidAPP' ) {
    model = gSTB.GetDeviceModel();
}

try {
    imageDate = JSON.parse(gSTB.GetEnv(JSON.stringify({varList: ['Image_Date']}))).result.Image_Date;
} catch ( error ) {
    console.log(error);
}

deviceInfo = [
    {
        label: gettext('Model'),
        value: model
    },
    {
        label: gettext('Serial'),
        value: gSTB.GetDeviceSerialNumber()
    },
    {
        label: gettext('MAC address'),
        value: gSTB.GetDeviceMacAddress()
    }
];

if ( core.device.model !== 'emulator' || core.device.model !== 'AndroidAPP' ) {
    deviceInfo.push({
        label: gettext('Vendor'),
        value: gSTB.GetDeviceVendor()
    });
}

deviceInfo = deviceInfo.concat(
    [
        {
            label: gettext('Hardware version'),
            value: gSTB.GetDeviceVersionHardware()
        },
        {
            label: gettext('Active bank'),
            value: activeBank
        },
        {
            label: gettext('Image version'),
            value: gSTB.GetDeviceImageVersion()
        },
        {
            label: gettext('IP address'),
            value: gSTB.RDir('IPAddress')
        },
        {
            label: gettext('Image description'),
            value: gSTB.GetDeviceImageDesc()
        },
        {
            label: gettext('Image date'),
            value: imageDate
        },
        {
            label: gettext('RootFS version'),
            value: gSTB.GetDeviceImageVersionCurrent()
        }
    ]
);

module.exports = deviceInfo;
